import * as React from "react";

import { SessionExpiredDialog } from "lib/components/SessionExpiredDialog";
import { Notification } from "lib/components/Notification";
import style from "./style.module.css";
import { List } from "../List";
import { DdlDialog } from "../Ddl";

export function App() {
  return (
    <div className={style.root}>
      <List />
      <DdlDialog />
      <SessionExpiredDialog />
      <Notification />
    </div>
  );
}
